import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CorrelationIdService } from '../services/correlation-id.service';

@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {

  private readonly correlationIdService = inject(CorrelationIdService);

  private readonly REQUEST_ID_HEADER = 'X-Correlation-ID';
  private readonly RESPONSE_ID_HEADER = 'x-correlation-id';

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Skip Keycloak/OpenID Connect endpoints
    if (
      req.url.includes('/protocol/openid-connect/') ||
      req.url.includes('/realms/')
    ) {
      return next.handle(req);
    }

    const correlationId =
      this.correlationIdService.getCorrelationId();

    const clonedRequest = req.clone({
      setHeaders: {
        [this.REQUEST_ID_HEADER]: correlationId,
      },
    });

    this.logRequest(clonedRequest, correlationId);

    return next.handle(clonedRequest).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {

            const responseCorrelationId =
              event.headers.get(this.RESPONSE_ID_HEADER);

            if (
              responseCorrelationId &&
              responseCorrelationId !== correlationId
            ) {
              this.correlationIdService.setCorrelationId(
                responseCorrelationId
              );
            }

            this.logResponse(event, correlationId);
          }
        },
        error: (error) => {
          this.logError(error, correlationId);
        },
      })
    );
  }

  private logRequest(req: HttpRequest<any>, correlationId: string): void {
    console.log('[HTTP Request]', {
      correlationId,
      method: req.method,
      url: req.url,
      timestamp: new Date().toISOString(),
    });
  }

  private logResponse(response: HttpResponse<any>, correlationId: string): void {
    console.log('[HTTP Response]', {
      correlationId,
      status: response.status,
      url: response.url,
      timestamp: new Date().toISOString(),
    });
  }

  private logError(error: any, correlationId: string): void {
    console.error('[HTTP Error]', {
      correlationId,
      error: error.message || error,
      status: error.status,
      url: error.url,
      timestamp: new Date().toISOString(),
    });
  }
}